import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import cn from 'classnames'

import styles from './styles.module.scss'

import { getAsset } from '../../../api'

import AssetStatus from '../AssetStatus'
import AssetBadge from '../AssetBadge'
import AssetOverview from '../AssetOverview'

const getTimeAgo = scan => {
  if (!scan) return ''
  const timeAgo = moment(scan.created_at).fromNow()
  return timeAgo
}

const getConditionStatus = condition => {
  if (['good', 'new'].includes(condition)) {
    return 'success'
  }
  if (['fair', 'need_attentions'].includes(condition)) {
    return 'warning'
  }
  if (['damaged', 'unsafe'].includes(condition)) {
    return 'danger'
  }
  return 'default'
}

const AssetDetails = ({companyId, assetId}) => {
  const { t } = useTranslation()

  const [activeTab, setActiveTab] = useState('overview')
  const [{asset, loading}, setAsset] = useState({asset: {scans: []}, loading: false})

  useEffect(() => {
    if (companyId && assetId) {
      getAsset(companyId, assetId).then(res => {
        setAsset({asset: res, loading: false})
      })
    }
  }, [companyId, assetId])

  const [lastScan] = asset.scans

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <div className={styles.header}>
          <div className={styles.image}>
            <img src={asset.details?.photo} />
          </div>
          <div className={styles.info}>
            <div className={styles.name}>{asset.name} {asset.details?.model} {asset.category?.name}</div>
            <div>
              <div className={styles.description}>{asset.code} · {asset.category?.name}</div>
              <div className={styles.description}>{asset.details?.manufacturer} · {asset.details?.model}</div>
            </div>
            <div className={styles.tags}>
              <AssetStatus status={asset.status} />
              <AssetBadge title={asset.ownership?.name} type={'default'} />
              <AssetBadge title={t('Condition: {{condition}}', {condition: asset.details?.condition})} type={getConditionStatus(asset.details?.condition)} />
            </div>
          </div>
          <div className={styles.actions}>
          </div>
        </div>
        <div className={styles.details}>
          <div className={styles.detailsCell}>
            <div className={styles.detailsCellTitle}>{t('Assigned to')}</div>
            <div className={styles.detailsCellValue}>{asset.employee ? `${asset.employee.name} ${asset.employee.surname}` : t('Unassigned')}</div>
            <div className={styles.detailsCellTitle}>{t('Employee')}</div>
          </div>
          <div className={styles.detailsCell}>
            <div className={styles.detailsCellTitle}>{t('Project')}</div>
            <div className={styles.detailsCellValue}>{asset.place ? `${asset.place.name}` : '-'}</div>
          </div>
          <div className={styles.detailsCell}>
            <div className={styles.detailsCellTitle}>{t('Current location')}</div>
            <div className={styles.detailsCellValue}>{lastScan ? lastScan.location : (asset.location || '-')}</div>
            <div className={styles.detailsCellTitle}>{lastScan ? t('Last known from scan') : ''}</div>
          </div>
          <div className={styles.detailsCell}>
            <div className={styles.detailsCellTitle}>{t('Last scan')}</div>
            <div className={styles.detailsCellValue}>{lastScan ? getTimeAgo(lastScan) : '-'}</div>
            <div className={styles.detailsCellTitle}> {lastScan ? `${lastScan?.action} · ${lastScan?.employee?.name} ${lastScan?.employee?.surname}` : '-'}</div>
          </div>
          <div className={styles.detailsCell}>
            <div className={styles.detailsCellTitle}>{t('Last inspection')}</div>
            <div className={styles.detailsCellValue}>{'-'}</div>
          </div>
        </div>
      </div>
      <div className={styles.tabBar}>
        <div className={cn(styles.tabBarItem, {[styles.active]: activeTab === 'overview'})} onClick={() => setActiveTab('overview')}>{t('Overview')}</div>
        <div className={cn(styles.tabBarItem, {[styles.active]: activeTab === 'timeline'})} onClick={() => setActiveTab('timeline')}>{t('Timeline')}</div>
        <div className={cn(styles.tabBarItem, {[styles.active]: activeTab === 'maintenance'})} onClick={() => setActiveTab('maintenance')}>{t('Maintenance')}</div>
        <div className={cn(styles.tabBarItem, {[styles.active]: activeTab === 'costs'})} onClick={() => setActiveTab('costs')}>{t('Costs')}</div>
        <div className={cn(styles.tabBarItem, {[styles.active]: activeTab === 'documents'})} onClick={() => setActiveTab('documents')}>{t('Documents')}</div>
      </div>
      <div className={styles.tabContent}>
        {
          (tab => {
            switch (tab) {
              case 'overview':
                return (
                  <AssetOverview asset={asset} />
                )
              default:
                return null
            }
          })(activeTab)
        }
      </div>
    </div>
  )
}

export default AssetDetails
